import React, { useState } from 'react';
import { CheckIcon, TrophyIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { plans } from '../data/content';
export function PricingSection() {
  const [selectedId, setSelectedId] = useState<string>(plans.find(plan => plan.featured)?.id ?? plans[0].id);
  const selectedPlan = plans.find(plan => plan.id === selectedId) ?? plans[0];
  return <section id="pricing" className="w-full scroll-mt-4 bg-ink px-5 py-14 sm:px-8 sm:py-20" aria-labelledby="planes-title" data-id="element-195" data-mp="1naam7jw18u2s">
      <div className="mx-auto max-w-3xl" data-id="element-196" data-mp="1x86vs79bngys">
        <CountdownTimer heading="⏰ Precio de lanzamiento — cierra en:" note="⚠️ Después sube $5.000 ARS. No vuelve." data-id="element-197" data-mp="1x99n2gak3lf8" />

        <div className="mt-6 rounded-2xl border border-line bg-surface p-5" data-id="element-198" data-mp="2uyv3yyo0b58">
          <p className="text-sm font-bold text-white" data-id="element-199" data-mp="2x1vncxg1mo7">
            🔴 Cupos al precio de lanzamiento — Quedan pocos
          </p>
          <div className="mt-3 h-2.5 w-full overflow-hidden rounded-full bg-ink" role="progressbar" aria-valuenow={72} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos al precio de lanzamiento tomados" data-id="element-200" data-mp="1mh6ld1i2366i">
            <div className="h-full w-[72%] rounded-full bg-ember" data-id="element-201" data-mp="17sadb4g01t5w" />
          </div>
          <p className="mt-2 text-xs font-medium text-neutral-400" data-id="element-202" data-mp="25fireedo7zxv">
            72% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>

        <h2 id="planes-title" className="mt-9 text-center text-2xl font-extrabold uppercase tracking-tight text-white sm:text-4xl" data-id="element-203" data-mp="20gz9cp2778as">
          Elegí tu <span className="text-gold-gradient" data-id="element-204" data-mp="1repwhsjgj2u8">plan</span>
        </h2>

        <fieldset className="mt-5" data-id="element-205" data-mp="k1xxz8ifcu5a">
          <legend className="sr-only" data-id="element-206" data-mp="k2z91czfxgn0">Elegí tu plan</legend>
          <div className="space-y-3" data-id="element-207" data-mp="g0uhcjsjyu30">
            {plans.map(plan => {
            const isSelected = plan.id === selectedId;
            return <label key={plan.id} className={`relative flex cursor-pointer items-start gap-3 rounded-2xl border p-4 transition-colors duration-150 ease-out sm:gap-4 sm:p-5 ${isSelected ? 'border-gold bg-gold/[0.06] shadow-gold' : 'border-line bg-surface hover:border-gold/40'}`} data-id="element-208" data-mp="hib45vd7yns7">
                  <input type="radio" name="megapack-plan" value={plan.id} checked={isSelected} onChange={() => setSelectedId(plan.id)} className="mt-1 h-4 w-4 shrink-0 accent-gold" data-id="element-209" data-mp="3uuti6mbnz0ss" />
                  <div className="min-w-0 flex-1" data-id="element-210" data-mp="3by24qtiszfwn">
                    <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-1" data-id="element-211" data-mp="3bybucfzxrl1t">
                      <h3 className="text-base font-extrabold leading-tight tracking-tight text-white sm:text-lg" data-id="element-212" data-mp="3fyvtfp42kyql">
                        {plan.featured ? <TrophyIcon className="mr-1.5 inline h-4 w-4 text-gold" aria-hidden="true" data-id="element-213" data-mp="2scjtp4strlsq" /> : <span className="mr-1.5" aria-hidden="true" data-id="element-214" data-mp="31bn8vxovfh1y">
                            {plan.emoji}
                          </span>}
                        {plan.name}
                      </h3>
                      <p className="flex shrink-0 items-baseline gap-2" data-id="element-215" data-mp="3bambayj1mggi">
                        <span className="text-xs text-neutral-600 line-through" data-id="element-216" data-mp="3p0zhowgadn3q">
                          {plan.oldPrice}
                        </span>
                        <span className="text-xl font-extrabold tracking-tight text-gold sm:text-2xl" data-id="element-217" data-mp="2v2lyalhti6q">
                          {plan.price}
                        </span>
                      </p>
                    </div>
                    <p className="mt-1.5 text-xs font-semibold text-neutral-300 sm:text-sm" data-id="element-218" data-mp="hyvwgaw35ano">
                      {plan.includes}
                    </p>
                    <p className="mt-1 text-xs leading-relaxed text-neutral-500" data-id="element-219" data-mp="lxl5jra3c61i">
                      <span className="font-semibold text-gold/80" data-id="element-220" data-mp="qr67tvipvm6i">
                        Ideal para:
                      </span>{' '}
                      {plan.idealFor}
                    </p>
                  </div>
                  {plan.featured ? <span className="absolute -top-2.5 right-4 rounded-full bg-gold px-2.5 py-0.5 text-[9px] font-extrabold uppercase tracking-[0.14em] text-ink" data-id="element-221" data-mp="301vqlft6je1">
                      Más elegido
                    </span> : null}
                </label>;
          })}
          </div>
        </fieldset>

        <div className="mt-5" data-id="element-222" data-mp="1jek0hhfdtvkt">
          <CtaButton href={selectedPlan.checkoutUrl} trackingLabel={selectedPlan.name} data-id="element-223" data-mp="1oe6azj3tsxpx">
            {selectedPlan.cta}
          </CtaButton>
          <p className="mt-3 flex items-center justify-center gap-1.5 text-xs text-neutral-500" data-id="element-224" data-mp="38vfk9ak1k7bh">
            <CheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-225" data-mp="33xw0jv4kr2c5" />
            Garantía 7 días · Acceso en 5 minutos · Mercado Pago
          </p>
        </div>
      </div>
    </section>;
}